export default __webpack_public_path__ + "static/media/Seller_Reading1.50b16298.png";